import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { UtmCapture } from '../components/UtmCapture';
import { motion } from 'framer-motion';
import { Wind, Award, ShieldCheck, Rocket, Radio, MapPin, Palmtree, Music, Coffee, Package } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WingFoilPage() {
  useEffect(() => {
    // Set meta tags for Wing Foil page
    document.title = "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Wing Foil בכנרת - לעוף מעל המים! חוף מושלם עם רוח צד, הדרכות למתחילים ומתקדמים, ציוד חדיש');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'Wing Foil בכנרת - הדור הבא של גלيشה. חוף מושלם, הדרכות מקצועיות וציוד חדיש'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'Wing Foil בכנרת - לעוף מעל המים'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1943">
      <UtmCapture data-id="element-1944" />
      <Navigation data-id="element-1945" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-1946">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-1947" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg" alt="Wing Foil Activity" className="w-full h-full object-cover" style={{
        objectPosition: '60% 38%',
        transform: 'scale(2.0)'
      }} data-id="element-1948" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1949">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1950">
            Wing Foil
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-3xl mb-2 font-medium" data-id="element-1951">
            ווינג פויל
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-1952">
            לעוף מעל המים - הדור הבא של גלisha
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1953">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1954">
          <div data-id="element-1955">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-1956">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-1957">
              ה-Wing Foil הוא הספורט הימי החדשני ביותר שכבש את העולם. הוא משלב
              כנף (Wing) המוחזקת ביד וגלשן עם סנפיר (Foil) המאפשר ריחוף מעל
              המים. התחושה היא של שקט מוחלט ומהירות, כמעט ללא חיכוך עם המים.
              הכנרת, עם הרוחות היציבות שלה בשעות הצהריים, היא המקום המושלם ללמוד
              ולהתקדם בספורט זה.
            </p>

            {/* Perfect Spot Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cyan-50 to-teal-50 border border-cyan-100 rounded-2xl p-6 mb-8" data-id="element-1958">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1959">
                <Wind className="w-7 h-7 text-cyan-600" data-id="element-1960" />
                חוף מושלם לגלישת Wing
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-1961">
                <p className="flex items-start gap-2" data-id="element-1962">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1963" />
                  <span data-id="element-1964">
                    <strong data-id="element-1965">רוח צד (Side Shore)</strong> - תנאי רוח אידיאליים
                    לגלisha בטוחה
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-1966">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1967" />
                  <span data-id="element-1968">
                    <strong data-id="element-1969">רוח יציבה כמעט כל יום</strong> במשך העונה
                    (אפריל-אוקטובר)
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-1970">
                  <MapPin className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1971" />
                  <span data-id="element-1972">
                    <strong data-id="element-1973">חניה קרובה למים</strong> - נוחות מקסימלית
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-1974">
                  <Palmtree className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1975" />
                  <span data-id="element-1976">
                    <strong data-id="element-1977">מדשאות</strong> לנוחות והכנת ציוד
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-1978">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1979" />
                  <span data-id="element-1980">
                    <strong data-id="element-1981">מתקן לטליית ווינגים וקומפרסור</strong>
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-1982">
                  <Music className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1983" />
                  <span data-id="element-1984">
                    <strong data-id="element-1985">מוזיקה ופינת קפה</strong> - אווירה מושלמת
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-1986">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-1987" />
                  <span data-id="element-1988">
                    <strong data-id="element-1989">אחסון ציוד</strong> - ניתן לאחסן את הציוד שלכם במקום
                  </span>
                </p>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1990">
              יתרונות ה-Wing Foil
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-1991">
              {['ציוד קל ונייד שקל להכין לפעילות', 'בטיחותי יותר מסוגי גלישות אחרים', 'עקומת למידה מהירה יחסית', 'תחושת ריחוף ייחודית וממכרת'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-1992">
                  <div className="bg-cyan-100 p-1 rounded-full" data-id="element-1993">
                    <Rocket className="w-4 h-4 text-cyan-600" data-id="element-1994" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-1995">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-1996">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-1997">
              <div className="flex gap-4" data-id="element-1998">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1999">
                  <ShieldCheck className="w-6 h-6 text-cyan-500" data-id="element-2000" />
                </div>
                <div data-id="element-2001">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2002">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2003">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד גולשים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2004">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2005">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2006" />
                </div>
                <div data-id="element-2007">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2008">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2009">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2010">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2011">
                  <Award className="w-6 h-6 text-cyan-500" data-id="element-2012" />
                </div>
                <div data-id="element-2013">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2014">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2015">
                    הצטרפו לקהילת גולשים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2016">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2017">
                  <Radio className="w-6 h-6 text-cyan-500" data-id="element-2018" />
                </div>
                <div data-id="element-2019">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2020">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2021">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2022">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2023">
                  <Package className="w-6 h-6 text-cyan-500" data-id="element-2024" />
                </div>
                <div data-id="element-2025">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2026">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2027">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2028">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2029">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2030" />
                </div>
                <div data-id="element-2031">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2032">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2033">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-2034">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-2035">
                רוצה להתחיל לעוף!
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-2036" />
      <Footer data-id="element-2037" />
    </div>;
}